import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
import { observer } from 'mobx-react';
import { URL_PRODUCT_PERMISSIONS_DOC } from '@/catalog/constants/urls';
import Button, { NEUTRAL_NOT_SO_LIGHT, PRIMARY } from '@/common/components/Button/Button';
import ButtonContainer from '@/common/components/ButtonContainer/ButtonContainer';
import DocumentationLink from '@/common/components/DocumentationLink/DocumentationLink';
import Icon from '@/common/components/Icon/Icon';
import Notifier from '@/common/services/Notifier';
import { useAppStore } from '@/common/stores/AppStore';
import { usePrivateAccessModalStore } from '@/security/components/PrivateAccessModal/PrivateAccessModalStore';
import { isValidAccessFormData } from '@/security/types/AccessFormData';
import styles from './PrivateAccessModalFooter.module.less';
function PrivateAccessModalFooter(props) {
    const { onClose, onSuccess, onAddForm } = props;
    const { isUpdating, updateACl, forms, canChangeCutDataAccess } = usePrivateAccessModalStore();
    const { isPhone } = useAppStore();
    const handleSubmit = useCallback(async () => {
        if (forms.some((f) => !isValidAccessFormData(f, canChangeCutDataAccess))) {
            Notifier.warn('Please fill in all required fields');
            return;
        }
        const updatedEntities = await updateACl();
        onClose();
        onSuccess?.(updatedEntities);
    }, [forms, canChangeCutDataAccess]);
    return (_jsxs("div", { className: styles.personalAccessFooter, children: [_jsxs("div", { className: styles.leftGroup, children: [_jsxs(Button, { className: styles.button, color: NEUTRAL_NOT_SO_LIGHT, onClick: onAddForm, disabled: isUpdating, iconPosition: "left", children: [_jsx(Icon, { name: "plus" }), isPhone ? 'Add' : 'Add People'] }), _jsx(DocumentationLink, { className: styles.helpLink, iconOnly: true, href: URL_PRODUCT_PERMISSIONS_DOC })] }), _jsxs(ButtonContainer, { children: [_jsx(Button, { className: styles.button, color: NEUTRAL_NOT_SO_LIGHT, disabled: isUpdating, onClick: onClose, children: "Cancel" }), _jsx(Button, { className: styles.button, color: PRIMARY, loading: isUpdating, onClick: handleSubmit, children: "Ok" })] })] }));
}
export default observer(PrivateAccessModalFooter);
